import React, { useEffect, useState, useRef } from 'react';
import LoaderComponent from '../../ReusableComponents/LoaderComponent';
import InfiniteScroll from 'react-infinite-scroll-component';
import reloadLogo from '../../assets/up-arrow.png';
import Tippy from '@tippyjs/react';
import IncentiveDetailsCard from './IncentiveDetailsCard';

export default function RecentIncentivesSection({
  previousIncentivesLoading,
  filters,
  hasMore,
  incentives,
  selectedIncentive,
  handleIncentiveClick,
  isLoading,
  previousRequestLoading,
  fetchMoreIncentives,
  fetchPreviousIncentives,
}) {
  const [page, setPage] = useState(1);
  const [isAtTop, setIsAtTop] = useState(true);
  const scrollableDivRef = useRef(null);

  useEffect(() => {
    setPage(filters?.pageNumber);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollableDivRef.current) {
        setIsAtTop(scrollableDivRef.current.scrollTop === 0);
      }
    };

    const scrollableDiv = scrollableDivRef.current;
    if (scrollableDiv) {
      scrollableDiv.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (scrollableDiv) {
        scrollableDiv.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  return (
    <div className='w-[100%] border border-r-[#D9D9D9] rounded-tl-[15px] rounded-bl-[15px] h-[100%] flex flex-col relative'>
      <p className='px-8 pt-6 pb-4 text-[18px] font-manrope font-[700]'>All Incentives</p>
      <div
        className='h-[90%] max-h-[90%] overflow-y-scroll px-0'
        id="scrollableDiv"
        ref={scrollableDivRef}
      >
    

        {previousRequestLoading && (
          <div className="z-10 w-full mt-2 flex justify-center absolute">
            <LoaderComponent width={"6%"} height={"6%"} />
          </div>
        )}

        {page > 1 && isAtTop && (
          <div className="absolute z-10 mt-2 w-full flex justify-center cursor-pointer">
            {!previousRequestLoading && (
                <img
                  src={reloadLogo}
                  width={30}
                  height={10}
                  alt='reload-img'
                  onClick={() => {
                    fetchPreviousIncentives(page - 1);
                    setPage(page - 1);
                  }}
                  disabled={isLoading}
                />
            )}
          </div>
        )}

        <InfiniteScroll
          dataLength={incentives?.length}
          next={() => {
            const nextPageNumber = filters?.pageNumber + 1;
            fetchMoreIncentives(nextPageNumber);
          }}
          endMessage={
            <p className='font-manrope font-[700] text-[15px] mt-2 text-center'>
              All Requests are fetched!
            </p>
          }
          hasMore={hasMore}
          loader={isLoading && <LoaderComponent width={"10%"} height={"25%"} />}
          scrollableTarget="scrollableDiv"
        >
          {incentives && incentives?.length > 0 && incentives?.map((incentive) => (
            <IncentiveDetailsCard
              key={incentive.id}
              incentive={incentive}
              selectedIncentive={selectedIncentive}
              handleClick={(incentive) => handleIncentiveClick(incentive)}
            />
          ))}
        </InfiniteScroll>
      </div>
    </div>
  );
}
